module.exports = {
  // 成员页
  member: {
    //首页
    index1: "我的群组",
    index2: "健康群组",
    index3: "点击查看健康数据",
    index4: "创建群组",
    index5: "我加入的群组",
    index6: "数据异常设置",
    index7: "暂无群组",
    index8: "暂未加入群组",
    index9: "待处理",
    index10: "通过二维码/微信/手机/邮箱等邀请加入",

    //创建群组
    addgroup1: "群组名称",
    addgroup2: "群组类型",
    addgroup3: "请填写群组名称",
    addgroup4: "家庭",
    addgroup5: "公司",
    addgroup6: "好友",
    addgroup7: "医院病房",
    addgroup8: "学校教室",
    addgroup9: "确定",
    addgroup10: "取消",
    addgroup11: "保存",
    addgroup12: "群组名已经存在",

    //成员列表
    memberlist1: "成员列表",
    memberlist2: "有",
    memberlist3: "项异常",
    memberlist4: "正常",
    memberlist5: "邀请新成员",
    memberlist6: "解散",
    memberlist7: "暂无成员",
    memberlist8: "加载中...",
    memberlist9: "是否解散此群？",
    memberlist10: "解散成功",
    memberlist11: "保存成功",
    memberlist12: "修改群组信息",
    memberlist13: "解散群组",
    memberlist14: "健康概览",
    memberlist15: "项正常",
    memberlist16: "项异常",
    memberlist17: "点击查看",
    memberlist18: "昨日无数据",
    memberlist19: "昨日",

    //修改成员
    updatemember1: "头像",
    updatemember2: "更换",
    updatemember3: "原昵称",
    updatemember4: "修改昵称",

    //健康数据
    healthdata1: "的健康数据",
    healthdata2: "健康数据",
    healthdata3: "周日",
    healthdata4: "周一",
    healthdata5: "周二",
    healthdata6: "周三",
    healthdata7: "周四",
    healthdata8: "周五",
    healthdata9: "周六",
    healthdata10: "心率",
    healthdata11: "血压",
    healthdata12: "收缩压",
    healthdata13: "舒张压",
    healthdata14: "体温",
    healthdata15: "血氧饱和度",
    healthdata16: "睡眠",
    healthdata17: "血脂四项",
    healthdata18: "胆固醇",
    healthdata19: "甘油三酯",
    healthdata20: "低密度脂蛋白胆固醇",
    healthdata21: "高密度脂蛋白胆固醇",
    healthdata22: "血糖",
    healthdata23: "餐前",
    healthdata24: "餐后",
    healthdata25: "尿酸",
    healthdata26: "胎心",
    healthdata27: "步数",
    healthdata28: "步",
    healthdata29: "卡路里",
    healthdata30: "千卡",
    healthdata31: "距离",
    healthdata32: "千米",
    healthdata33: "配速",
    healthdata35: "秒/公里",
    healthdata36: "分",
    healthdata37: "正在加载健康数据",
    healthdata38: "运动记录",
    healthdata39: "异常",
    healthdata40: "未授权",
    healthdata41: "修改成员信息",
    healthdata42: "删除成员",
    healthdata43: "邮箱：",
    healthdata44: "手机：",
    healthdata45: "是否删除此成员？",

    //邀请成员
    addmember1: "邀请成员",
    addmember2: "让关心你健康的人更加关心你跨越距离，关爱更及时",
    addmember4: "无论多遥远，亲友之间可以实时查看健康状况",
    addmember5: "了解详情",
    addmember6: "群组成员",
    addmember7: "邀请",
    addmember8: "加入",
    addmember9: "扫码邀请",
    addmember10: "微信邀请",
    addmember11: "通过扫二维码邀请加入群组",
    addmember12: "通过微信邀请加入群组",
    addmember13: "手机号/邮箱邀请",
    addmember14: "通过手机号/邮箱邀请加入群组",

    // 群组二维码
    code1: "群组二维码",
    code2: "健康管理群",
    code3: "该二维码5分钟内有效，请及时使用",

    //群组邀请
    invide1: "群组邀请",
    invide2: "成员健康",
    invide3: "邀请你加入群组...",
    invide4: "加入该群组",
    invide5: "为了您的数据安全，建议在加入群组前核查群组信息",
    invide6: "加入群组后，您将授权关注者可以查看您的健康数据 ",

    //分享健康数据设置
    sethealthdata1: "健康数据设置",
    sethealthdata2: "确定",
    sethealthdata3: "请设置昵称",
    sethealthdata4: "全部允许",
    sethealthdata5: "设置昵称",
    sethealthdata6: "保存",
    sethealthdata7: "请输入",
    sethealthdata8: "请上传图片格式",
    sethealthdata9: "请设置昵称和头像",
    sethealthdata10: "请设置头像",
    sethealthdata11: "昵称长度为1-8个字符",
    // 设置数据区间
    setscope1: "心率上下限区间",
    setscope2: "体温上下限区间",
    setscope3: "睡眠上下限区间",
    setscope4: "胎心上下限区间",
    setscope5: "餐前血糖",
    setscope6: "餐后血糖",
    setscope7: "血氧上下限区间",
    setscope8: "男性尿酸",
    setscope9: "女性尿酸",
    setscope10: "收缩压",
    setscope11: "舒张压",
    setscope12: "上限",
    setscope13: "下限",
    setscope14: "预警设置",
    setscope15: "设置成功",
    setscope16: "上限",
    setscope17: "下限",

    //下载页
    onload1: "点击",
    onload2: "加入健康群组",
    onload3: "请用浏览器打开",
    onload4: "知道了",
    onload5: "友宏健康 智享健康每一天",
    onload6: "appstore免费下载",
    onload7: "免费下载",
    onload8: "链接已失效",
    onload9: "二维码已失效",
    onload10: "加入成功",

    // 待处理
    pending1: "同意",
    pending2: "拒绝",
    pending3: "重新发送邀请",
    pending4: "暂无数据",
    pending5: "邀请已发送，等待用户同意邀请",
    pending6: "确认",

    guide1: "进入成员健康后，需要先创建相应类型的群组。",
    guide2:
      "创建群组后，进入群组中，可以查看用户的健康概览，也可以邀请新成员进入群组。",
    guide3:
      "群组中邀请新成员，可通过扫码，微信，手机号/邮箱等方式邀请。新成员加入群组后，您可查看TA每天的健康动态。",
    guide4: "点击查看健康概览，可以查看成员的健康数据，并可判断正常与异常。",
    guide5: "下一步",
    guide6: "完成",

    invite1: "通过手机号/邮箱邀请",
    invite2: "请输入账号",
    invite3: "请输入手机号",
    invite4: "请输入邮箱",
    invite5: "请输入正确的手机号",
    invite6: "请输入正确的邮箱",
    invite7: "已加入该群组",
    invite8: "用户不存在",
    invite9: "请选择国家或地区",
    invite10: "请输入搜索关键词",
    invite11: "确认用户",
    invite12: "邀请TA"
  },

  // 成员页
  JCRing_member: {
    //首页
    index1: "Terveysyhteisö",
    index2: "Terveysryhmä",
    index3: "jäsen",
    index4: "Lisää ryhmä",
    index5: "Liitytty ryhmään",
    index6: "Ilmoitusasetukset",
    index7: "Välitä läheistesisi terveydestä",
    index8: "Ei ryhmiä",
    index9: "Tiedot",
    index10: "Kutsu liittymään puhelimella/sähköpostilla/QR-koodilla",

    //创建群组
    addgroup1: "Ryhmän nimi",
    addgroup2: "Ryhmän tyyppi",
    addgroup3: "Syötä ryhmän nimi",
    addgroup4: "Perheryhmä",
    addgroup5: "Yritysryhmä",
    addgroup6: "Muu ryhmä",
    addgroup7: "Sairaalaryhmä",
    addgroup8: "Kouluryhmä",
    addgroup9: "Vahvista",
    addgroup10: "Peruuta",
    addgroup11: "Luo uusi ryhmä",
    addgroup12: "Ryhmän nimi on jo käytössä",

    //成员列表
    memberlist1: "Jäsenlista",
    memberlist2: "on",
    memberlist3: "Poikkeavuuksia",
    memberlist4: "Normaali",
    memberlist5: "Lisää jäsen",
    memberlist6: "Poista",
    memberlist7: "Ei jäseniä",
    memberlist8: "ladataan…",
    memberlist9: "Poista ja poistu ryhmästä?",
    memberlist10: "Poistaminen onnnistui",
    memberlist11: "Tallentaminen onnistui",
    memberlist12: "Muokkaa",
    memberlist13: "Hylkää",
    memberlist14: "Terveystiedot",
    memberlist15: "Normaali",
    memberlist16: "Epänormaali",
    memberlist17: "lisää tietoja",
    memberlist18: "Ei tietoja eiliseltä",
    memberlist19: "Eilinen",
    memberlist20: "Kutsuit juuri",
    memberlist21: "liittyäksesi ryhmäänxxx, vahvista!",

    //修改成员
    updatemember1: "Profiili",
    updatemember2: "Muuta",
    updatemember3: "Vanha lempinimi",
    updatemember4: "Vaihda lempinimi",

    //健康数据
    healthdata1: "terveystiedot",
    healthdata2: "terveystiedot",
    healthdata3: "su",
    healthdata4: "ma",
    healthdata5: "ti",
    healthdata6: "ke",
    healthdata7: "to",
    healthdata8: "pe",
    healthdata9: "la",
    healthdata10: "Syke",
    healthdata11: "sykevälivaihtelu",
    healthdata12: "systolinen ",
    healthdata13: "diastolinen ",
    healthdata14: "Kehon lämpötila",
    healthdata15: "Happipitoisuus",
    healthdata16: "uni",
    healthdata17: "veren lipidejä",
    healthdata18: "kolesteroli",
    healthdata19: "triglyseridi",
    healthdata20: "Matalatiheyksinen lipoproteiini (LDL-C)",
    healthdata21: "Korkean tiheyden lipoproteiini (HDL-C)",
    healthdata22: "Veren glukoosi",
    healthdata23: "Ennen ruokailua",
    healthdata24: "Ruokailun jälkeen",
    healthdata25: "Hapenottokyky",
    healthdata26: "Hengitys",
    healthdata27: "Askelta",
    healthdata28: "Askelta",
    healthdata29: "Kaloreja",
    healthdata30: "kcal",
    healthdata31: "Matka",
    healthdata32: "km",
    healthdata33: "Vauhti",
    healthdata35: "/km",
    healthdata36: "",
    healthdata37: "Luodaan terveysraporttia",
    healthdata38: "Aktiivisuus",
    healthdata39: "Varhaisvaroitus",
    healthdata40: "Luvaton ",
    healthdata41: "Muokkaa",
    healthdata42: "Poista",
    healthdata43: "Sähköposti: ",
    healthdata44: "Puhelin: ",
    healthdata45: "Vahvista poistaminen",
    healthdata46: "Tulevia päivämääriä ei voi näyttää",
    healthdata47: "Tänään",


    //邀请成员
    addmember1: "Lisää",
    addmember2: "Lisää Katin ID (Kati on nimi)",
    addmember4:
      "Voit tarkastella jäsentesi terveystietoja ja säätää hänen asetustaan.",
    addmember5: "Tietoja",
    addmember6: "Ryhmän jäsenet",
    addmember7: "Kutsu",
    addmember8: "Lisää",
    addmember9: "QR-koodi",
    addmember10: "WeChat",
    addmember11: "Kutsu liittymään ryhmään skannaamalla QR-koodi",
    addmember12: "Kutsu liittymään WeChatin kautta",
    addmember13: "Puhelin/sähköposti",
    addmember14: "Liity puhelimen/sähköpostin välityksellä",
    addmember15:
      "Saat tietoa jäsenten terveystilasta pyytämällä heitä liittymään",
    addmember16: "Lähetä kutsuja",
    addmember17: "Lähetetty",
    addmember18: "vahvistetaan",
    addmember19: "Liittynyt",
    addmember20: "Jaa nyt",
    addmember21: "tallenna kuva",
    addmember22: "Estetty",
    addmember23: "luovu",
    addmember24: "Toinen osapuoli on poistunut",
    addmember25: "Toinen osapuoli on hylännyt",
    addmember26: "Toinen osapuoli on liittynyt",
    addmember27: "Muita tapoja lisätä se", 


    // 群组二维码
    code1: "Ryhmän QR-koodi",
    code2: "Terveysyhteisö",
    code3: "QR-koodi on voimassa 5 minuuttia, lue ajallaan",

    //群组邀请
    invide1: "Ryhmäkutsu",
    invide2: "Terveysyhteisö",
    invide3: "pyysi sinua liittymään ryhmään…",
    invide4: "Liity ryhmään ?",
    invide5:
      "Tietoturvallisuudesta johtuen tarkasta ryhmän tiedot ennen liittymistä.",
    invide6:
      "Liityttyäsi ryhmään voit antaa luvan tietylle ryhmälle nähdä terveystietosi",

    //分享健康数据设置
    sethealthdata1: "Terveystietoasetukset",
    sethealthdata2: "Vahvista",
    sethealthdata3: "Lempinimeä ei ole asetettu",
    sethealthdata4: "Hyväksy kaikki",
    sethealthdata5: "Lempinimi asetettu",
    sethealthdata6: "Tallenna",
    sethealthdata7: "Siirry",
    sethealthdata8: "Lataa kuva",
    sethealthdata9: "Lempinimeä ei ole asetettu",
    sethealthdata10: "Ei profiilia asetettu",
    sethealthdata11: "Lempinimen pituus on 1-8 merkkiä",
    // 设置数据区间
    setscope1: "Sykehälytys",
    setscope2: "Kehon lämpötilan hälytys",
    setscope3: "Unihälytys",
    setscope4: "Sikiön syke",
    setscope5: "Paasto  veren glukoosi",
    setscope6: "Aterian jälkeinen veren glukoosi",
    setscope7: "Happisaturaatiovaroitus",
    setscope8: "Miehen virtsahappo",
    setscope9: "Naisen virtsahappo",
    setscope10: "Systolinen",
    setscope11: "Diastolinen",
    setscope12: "Korkea",
    setscope13: "Matala",
    setscope14: "Hälytyksen asetus",
    setscope15: "Asetettu onnistuneesti",
    setscope16: "Liian paljon",
    setscope17: "Liian vähän",
    setscope18: "Hälytys",

    //下载页
    onload1: "Klikkaa",
    onload2: "Liity ryhmään",
    onload3: "Avaa selaimella",
    onload4: "Vahvista",
    onload5: "Nauti terveydestä joka päivä",
    onload6: "Ilmaiseksi ladattavissa App Storesta",
    onload7: "Ilmaiseksi ladattavissa App Storesta",
    onload8: "Linkki on vanhentunut",
    onload9: "QR-koodi on vanhentunut",
    onload10: "Onnistuneesti liitytty",

    // （消息中心）待处理
    pending1: "Hyväksy",
    pending2: "Kieltäydy",
    pending3: " Lähetä kutsu uudelleen",
    pending4: " Ei tietoja",
    pending5: "Kutsu on jo lähetetty,odota vahvistusta.",
    pending6: "vahvista",
    pending7: "poistu",

    guide1: "Luo terveysryhmä ja nimeä se",
    guide2:
      "Voit tarkistaa ryhmän jäsenten terveystiedot ja kutsua myös uuden jäsenen liittymään tähän terveysryhmään.",
    guide3:
      "Voit kutsua uusia jäseniä QR-koodin, wechatin, matkapuhelimen tai sähköpostin kautta. Kun uusi jäsen liittyy ryhmään, voit tarkistaa hänen terveystietonsa",
    guide4: "Voit tarkistaa ryhmän jäsenten terveyshistorian",
    guide5: "Seuraava",
    guide6: "OK",
    guide7: "varoitus",

    invite1: "Liity puhelimella/sähköpostilla",
    invite2: "Syötä tili",
    invite3: "Syötä puhelinnumero",
    invite4: "Syötä sähköposti",
    invite5: "Syötä oikea puhelinnumero",
    invite6: "Syötä oikea sähköpostiosoite",
    invite7: "Olet jo liittynyt ryhmään",
    invite8: "Käyttäjää ei löydy",
    invite9: "Valitse maa tai alue",
    invite10: "Anna hakusana",
    invite11: "Käyttäjä",
    invite12: "Kutsu"
  }
};



// WEBPACK FOOTER //
// ./src/lang/fi.js